import { createSlice } from "@reduxjs/toolkit"
import { EnumReduces } from "@/lib/redux/type"
import { storeInitialState } from "./initialState"
import { generateThunkHandler } from "@/utils/redux/generateThunkHandler"
import { storeEndpoints, StoreEnumEndpointsName } from "./endpoint"
import { callbackGetCategoryList } from "./callbacks/callbackGetCategoryList"

const storeSlice = createSlice({
  name: EnumReduces.STORE,
  initialState: storeInitialState,
  reducers: {
    setStoreData: (state, { payload }) => {
      state.store_setting.data = {
        ...storeInitialState.store_setting.data,
        ...payload
      }
      state.store_setting.loading = false
      state.store_setting.called = true
      state.store_setting.error = null
    },
    setCategoryListData: (state, action) => {
      callbackGetCategoryList && callbackGetCategoryList(state, action, StoreEnumEndpointsName.GET_CATEGORY_LIST)
    },
    setIsDesktop: (state, action) => {
      state.isDesktop = !!action.payload
    }
  },
  extraReducers(builder) {
    generateThunkHandler(builder, EnumReduces.STORE, Object.keys(storeEndpoints) as any)
  },
})

export const storeActions = storeSlice.actions

export default storeSlice.reducer